import React, { useEffect, useRef, useState, useMemo, lazy } from "react";

import moment from "moment";

import { Grid, Tooltip, Typography } from "@mui/material";

import axios from "axios";

import Layout from "../../../layout/Layout";

import { config, holidaydetailsAPI } from "../../../config";
import { AddHoliday } from "../../../components/AddHoliday";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { MaterialReactTable } from "material-react-table";

let field = "id",
  orderBy = "desc";

const Pagination = lazy(() => import("../../../components/ReactPagination"));

function AddHolidayDay() {
  const navigate = useNavigate();

  let intOffset = 0;
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [HolidayList, setHolidayList] = useState([]);

  let assetsRef = useRef(false);
  const childRef = useRef();

  const fetchData = (action) => {
    if (action === 1) {
      intOffset = 0;
    }
  };

  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1);
    }
  }, []);

  const fetchUsers = async (page, rowsPerPage) => {
    if (tempRefs.current === false) {
      const data = JSON.stringify({
        intLimit: rowsPerPage ? rowsPerPage : 10,
        intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
        intType: 3,
      });

      config.method = "POST";
      config.data = data;
      config.url = holidaydetailsAPI;

      axios(config)
        .then(function (response) {
          setHolidayList(response.data["result"]);
          setTotalCount(response.data.totalCount);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    tempRefs.current = true;
  };

  const handlePageChange = (page) => {
    tempRefs.current = false;
    fetchUsers(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!HolidayList.length) return;
    tempRefs.current = false;
    fetchUsers(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleSort = (column, sortDirection) => {
    setLoading(true);
    setTimeout(() => {
      field = column.field;
      orderBy = sortDirection;
      fetchUsers(1);
      setLoading(false);
    }, 100);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "holiday_date",
        header: "Holiday Date",
        enableSorting: true,
        size: 200, // Adjust width as needed
      },
      {
        accessorKey: "holiday_reason",
        header: "Reason",
        enableSorting: true,
        size: 300, // Adjust width as needed
      },
      {
        header: "Action",
        size: 100,
        Cell: ({ row }) => (
          <Tooltip title="Edit holiday" arrow>
            <IconButton
              color="success"
              onClick={() =>
                handleEditHolidays(
                  row.original.id,
                  row.original.holiday_date,
                  row.original.holiday_reason
                )
              }
              aria-label="edit holiday"
            >
              <EditLocationOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
        enableSorting: false,
      },
      {
        header: "Action",
        size: 100,
        Cell: ({ row }) => (
          <Tooltip title="Delete holiday" arrow>
            <IconButton
              color="error"
              onClick={() => handleRemoveHolidays(row.original.id)}
              aria-label="delete holiday"
            >
              <DeleteTwoToneIcon />
            </IconButton>
          </Tooltip>
        ),
        enableSorting: false,
      },
    ],
    []
  );

  const handleEditHolidays = (id, holidayDate, holidayReason) => {
    childRef.current.setData(
      JSON.stringify({
        intHolidayId: id,
        txtHolidayDate: holidayDate,
        txtHolidayReason: holidayReason,
        intType: 3,
        update: "yes",
        // fetchUsers: fetchUsers(1),
      })
    );
  };

  const handleRemoveHolidays = (id) => {
    const confirm = window.confirm("Are you sure want to delete this?");
    if (!confirm) return;

    const data = JSON.stringify({
      intHolidayId: id,
      intType: 5,
    });

    config.method = "POST";
    config.data = data;
    config.url = holidaydetailsAPI;

    axios(config)
      .then(function (response) {
        alert("Holiday has been deleted");

        setTimeout(function () {
          window.location.reload();
        }, 1000);
      })

      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Something went wrong",
            messageType: "error",
          })
        );
      });
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Add Holiday
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Holiday</Typography>
              <Typography color="text.primary">Add</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid className="form_design">
          <AddHoliday ref={childRef} fetchData={fetchData} />
          <div className="empty-space-20"></div>
          <Grid className="small_table">
            <MaterialReactTable
              columns={columns}
              enableGlobalFilter={false}
              // enableColumnActions={false}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              data={HolidayList}
              state={{
                isLoading: loading,
                pagination: {
                  pageIndex: currentPage - 1, // MRT uses zero-based index
                  pageSize: rowsPerPage,
                },
              }}
              manualPagination
              rowCount={totalCount}
              onPaginationChange={(updater) => {
                const newPagination =
                  typeof updater === "function"
                    ? updater({
                        pageIndex: currentPage - 1,
                        pageSize: rowsPerPage,
                      })
                    : updater;
                handlePageChange(newPagination.pageIndex + 1); // convert back to one-based
                handleRowsPerPageChange(newPagination.pageSize);
              }}
              enableStickyHeader
              muiTableContainerProps={{
                sx: { maxHeight: "550px" },
              }}
              muiTablePaperProps={{
                sx: {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  "& input": {
                    color: "#fff !important",
                    "&::placeholder": {
                      color: "#fff !important",
                      opacity: 1,
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "#fff !important", // selected text color
                  },
                  "& .MuiSelect-icon": {
                    color: "#fff !important", // dropdown arrow color
                  },
                  color: "#fff",
                  fontWeight: "bold",
                  "& svg": {
                    color: "#fff",
                  },
                  "& .MuiTableSortLabel-root": {
                    color: "#495057",
                    "&.Mui-active": {
                      color: "#fff",
                      "& .MuiTableSortLabel-icon": {
                        color: "#fff !important",
                      },
                    },
                  },
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              }}
              initialState={{
                density: "compact",
              }}
              muiTableBodyRowProps={({ row }) => ({
                sx: {
                  cursor: "pointer",
                },
              })}
              pageCount={Math.ceil(totalCount / rowsPerPage)}
              muiTablePaginationProps={{
                rowsPerPageOptions: [1, 10, 25, 50, 100],
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default AddHolidayDay;
